





























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';
// import { CompanyData } from '@/modules/exhibitor/company';
// import { ExhibitorData } from '@/modules/exhibitor/exhibitor';

export type Account = {
  email: string;
  password: string;
}

export type DataType = {
  ovid: string;
}

export default Vue.extend({
  name: 'GAccountEmailAndPw',
  data(): DataType {
    return {
      ovid: v4(),
    };
  },
  props: {
    account: {
      type: Object as PropType<Account>,
      required: true,
    },
    // email: {
    //   type: String as PropType<string>,
    //   default: null,
    // },
    // password: {
    //   type: String as PropType<string>,
    //   default: null,
    // },
  },
  methods: {
    vid(name: string) {
      return `${name}-${this.ovid}`;
    },
  },
  // data() {
  //   return {
  //     email: "",
  //     password: '',
  //   };
  // },
});
